import { Component, input, output } from '@angular/core';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';

@Component({
  selector: 'app-section-box',
  standalone: true,
  imports: [LinkComponent],
  templateUrl: './section-box.component.html',
  styleUrl: './section-box.component.scss'
})
export class SectionBoxComponent {

  disabled = input<boolean>(false);
  title = input.required<string>();
  titleActionClicked = output<string>();

  showFooter = input<boolean>(true);
  showTitleAction = input<boolean>(true);

  titleActionClick(identifier: string) {
    this.titleActionClicked.emit(identifier);
  }

}
